import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  role: "main",
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_4 = { class: "card-list" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_7 = { class: "card blue" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_12 = { class: "card orange" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_15 = { class: "card red" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_18 = { class: "card yellow" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_21 = { class: "card pink" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_24 = { class: "card purple" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_27 = { class: "card cryan" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_30 = { class: "card ngoaitru" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_33 = { class: "card noitru" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_36 = { class: "card doanhthunhathuoc" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "p-field p-col p-col-12 p-md-6 p-lg-2" }
const _hoisted_39 = { class: "card khamsuckhoe" }
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_42 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_45 = { class: "card" }
const _hoisted_46 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_47 = { class: "card" }
const _hoisted_48 = { class: "col-12 p-col-12 p-md-12 p-lg-6" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = { class: "col-12 p-col-12 p-md-12 p-lg-6" }
const _hoisted_51 = { class: "card" }
const _hoisted_52 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_53 = { class: "p-field p-col-12 p-sm-12 p-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_panel = _resolveComponent("panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Thông tin bệnh viện trực tuyến" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("main", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Tổng BN khám", -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "zmdi zmdi-upload" }, null, -1)),
                      _createElementVNode("div", _hoisted_8, _toDisplayString($setup.dashboard.slKham), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "card green",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showDetail && $setup.showDetail(...args)))
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "Tổng bn cũ", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "zmdi zmdi-upload" }, null, -1)),
                      _createElementVNode("div", _hoisted_10, _toDisplayString($setup.dashboard.bN_Cu), 1),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "Tổng BN mới", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_13, _toDisplayString($setup.dashboard.bN_Moi), 1),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, "Tổng BN ra viện", -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_16, _toDisplayString($setup.dashboard.bN_RaVien), 1),
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title" }, "Tổng BN chuyển", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_19, _toDisplayString($setup.dashboard.bN_ChuyenVien), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "title" }, "Tổng BN siêu âm", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_22, _toDisplayString($setup.dashboard.sieuAm), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "title" }, "Tổng BN xquang", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_25, _toDisplayString($setup.dashboard.xquang), 1),
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title" }, "Tổng BN XN", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_28, _toDisplayString($setup.dashboard.xetNghiem), 1),
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title" }, "Tổng VP ngoại trú", -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_31, _toDisplayString($setup.formatMoney($setup.dashboard.vienPhi_NgoaiTru)), 1),
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "title" }, "Tổng VP nội trú", -1)),
                      _cache[31] || (_cache[31] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_34, _toDisplayString($setup.formatMoney($setup.dashboard.vienPhi_NoiTru)), 1),
                      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "title" }, "DT nhà thuốc", -1)),
                      _cache[34] || (_cache[34] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_37, _toDisplayString($setup.formatMoney($setup.dashboard.doanhthu_nhathuoc)), 1),
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "title" }, "Số lượt khám SK", -1)),
                      _cache[37] || (_cache[37] = _createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)),
                      _createElementVNode("div", _hoisted_40, _toDisplayString($setup.dashboard.khamSucKhoe), 1),
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "stat" }, null, -1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Thống kê trong 10 ngày" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px","color":"#ef3b40"} }, "Biểu đồ thống kê lượt khám ", -1)),
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesData,
                options: $setup.basicOptionsLine,
                style: {"height":"400px"}
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px","color":"#ef3b40"} }, "Biểu đồ thống kê bệnh nhân cũ", -1)),
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesDataIn,
                options: $setup.basicOptionsLine,
                style: {"height":"400px"}
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px","color":"#ef3b40"} }, "Biểu đồ thống kê bệnh nhân mới", -1)),
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesDataNew,
                options: $setup.basicOptionsLine,
                style: {"height":"400px"}
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_panel, { header: "Biểu đồ viện phí nội trú" }, {
                default: _withCtx(() => [
                  _createVNode(_component_apexchart, {
                    type: "area",
                    options: $setup.chartOptionsNoiTru,
                    series: $setup.seriesNoiTru
                  }, null, 8, ["options", "series"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_panel, { header: "Biểu đồ viện phí ngoại trú" }, {
                default: _withCtx(() => [
                  _createVNode(_component_apexchart, {
                    type: "area",
                    options: $setup.chartOptions,
                    series: $setup.series
                  }, null, 8, ["options", "series"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: $setup.showDetailBNNT,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.showDetailBNNT) = $event)),
      style: { width: '70vw'},
      breakpoints: { '1500px': '90vw', '1150px': '100vw' },
      header: "CHI TIẾT BỆNH NHÂN NỘI TRÚ"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_DataTable, {
              value: $setup.listBenhNhanNoitru,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              filters: _ctx.filters,
              "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['phongBan','dangDT'],
              showGridlines: "",
              currentPageReportTemplate: "Có tổng số {totalRecords} khoa",
              columnResizeMode: "fit | expand"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "phongBan",
                  header: "Khoa",
                  sortabBle: ""
                }),
                _createVNode(_component_Column, {
                  field: "dangDT",
                  header: "Số lượng bệnh nhân",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["value", "filters"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}